module.exports = __webpack_public_path__ + "img/logo.0e15f593.png";